import { EOptionSymbolSide } from '@aqx-core/common/api/market';
import { socketService } from '@aqx-core/common/socket';
import { IOptionTopicLiveData } from '@aqx-core/common/socket/subscriptions';
import { EOptionMessageType, IOptionTopicMessage } from '@aqx-core/common/socket/topics/option';
import { safetyCheckForNumberValues } from '@aqx-core/common/utils/number';

class OptionTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    updateOptionChainData: (updatedSymbolId: string, updatedData: IOptionTopicLiveData) => void
  ) => {
    socketService.topics().option.subscribe({
      symbol: symbol,
      receiver: { subscriptionKey, payload: (payload) => this.optionTopicReceiver(payload, updateOptionChainData) }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    updateOptionChainData: (updatedSymbolId: string, updatedData: IOptionTopicLiveData) => void
  ) => {
    socketService.topics().option.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => this.optionTopicReceiver(payload, updateOptionChainData)
      }
    });
  };

  private optionTopicReceiver = (
    payload: IOptionTopicMessage | undefined,
    updateOptionChainData: (updatedSymbolId: string, updatedData: IOptionTopicLiveData) => void
  ) => {
    if (payload && payload.M === EOptionMessageType.LIVE) {
      updateOptionChainData(payload.D.S, this.massagePayload(payload));
    }
  };

  private massagePayload = (payload: IOptionTopicMessage) => {
    const updatedData: IOptionTopicLiveData = {
      expiration: payload.D.E ?? '',
      strikePrice: safetyCheckForNumberValues(payload.D.SP),
      symbol: payload.D.S,
      bid: safetyCheckForNumberValues(payload.D.B),
      ask: safetyCheckForNumberValues(payload.D.A),
      lastPrice: safetyCheckForNumberValues(payload.D.L),
      volume: safetyCheckForNumberValues(payload.D.V),
      openInterest: safetyCheckForNumberValues(payload.D.OI),
      impliedVolatility: safetyCheckForNumberValues(payload.D.IV),
      delta: safetyCheckForNumberValues(payload.D.D),
      gamma: safetyCheckForNumberValues(payload.D.G),
      vega: safetyCheckForNumberValues(payload.D.VG),
      theta: safetyCheckForNumberValues(payload.D.TH),
      side: (payload.D.SID as EOptionSymbolSide) ?? EOptionSymbolSide.CALL,
      prevClose: safetyCheckForNumberValues(payload.D.PC),
      timestamp: safetyCheckForNumberValues(payload.D.T)
      // bep: safetyCheckForNumberValues(payload.D.BEP),
      // probability: safetyCheckForNumberValues(payload.D.PRB),
    };

    return updatedData;
  };
}

export const optionTopicSubscription = new OptionTopicSubscription();
